/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postApiExportV1Export } from '../fn/export/post-api-export-v-1-export';
import { PostApiExportV1Export$Params } from '../fn/export/post-api-export-v-1-export';
import { postApiExportV1ExportCorporates } from '../fn/export/post-api-export-v-1-export-corporates';
import { PostApiExportV1ExportCorporates$Params } from '../fn/export/post-api-export-v-1-export-corporates';
import { postApiExportV1Roles } from '../fn/export/post-api-export-v-1-roles';
import { PostApiExportV1Roles$Params } from '../fn/export/post-api-export-v-1-roles';


/**
 * API controller for managing exporting users data.
 */
@Injectable({ providedIn: 'root' })
export class ExportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiExportV1Export()` */
  static readonly PostApiExportV1ExportPath = '/private/v1/users/export';

  /**
   * Export users data via csv.
   *
   * Export users data via csv
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiExportV1Export()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiExportV1Export$Response(params?: PostApiExportV1Export$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiExportV1Export(this.http, this.rootUrl, params, context);
  }

  /**
   * Export users data via csv.
   *
   * Export users data via csv
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiExportV1Export$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiExportV1Export(params?: PostApiExportV1Export$Params, context?: HttpContext): Observable<void> {
    return this.postApiExportV1Export$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiExportV1Roles()` */
  static readonly PostApiExportV1RolesPath = '/private/v1/roles/export';

  /**
   * Export roles data via csv.
   *
   * Export roles data via csv
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiExportV1Roles()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiExportV1Roles$Response(params?: PostApiExportV1Roles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiExportV1Roles(this.http, this.rootUrl, params, context);
  }

  /**
   * Export roles data via csv.
   *
   * Export roles data via csv
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiExportV1Roles$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiExportV1Roles(params?: PostApiExportV1Roles$Params, context?: HttpContext): Observable<void> {
    return this.postApiExportV1Roles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiExportV1ExportCorporates()` */
  static readonly PostApiExportV1ExportCorporatesPath = '/private/v1/corporate-groups/export';

  /**
   * Export corporateGroups data via csv.
   *
   * Export corporateGroups data via csv
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiExportV1ExportCorporates()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiExportV1ExportCorporates$Response(params?: PostApiExportV1ExportCorporates$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiExportV1ExportCorporates(this.http, this.rootUrl, params, context);
  }

  /**
   * Export corporateGroups data via csv.
   *
   * Export corporateGroups data via csv
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiExportV1ExportCorporates$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiExportV1ExportCorporates(params?: PostApiExportV1ExportCorporates$Params, context?: HttpContext): Observable<void> {
    return this.postApiExportV1ExportCorporates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
